module.exports = __webpack_public_path__ + "img/SEO.1c1949db.svg";